import { useTranslation } from "react-i18next";

import type { OpenAPI } from "simplydo/interfaces";
import { Button } from "simplydo/react/ui/button";
import { Loader } from "simplydo/react/ui/loader";

import IdeaProjectEventItem from "components/lib/ProjectBoard/ProjectEvents/IdeaProjectEventItem";
import { hasEventType } from "components/lib/ProjectBoard/ProjectEvents/ideaEventUtils";
import { useBoardEventsInfiniteQuery } from "components/lib/ProjectBoard/ProjectEvents/useBoardEventsInfiniteQuery";
import { EmptyBox } from "components/lib/UI";

type ManagementActivityProps = {
  idea: OpenAPI.GET<"/ideas/{id}">["response"];
  userIsAssigned?: boolean;
};

const ActivityManagement = ({ idea }: ManagementActivityProps) => {
  const { t } = useTranslation();
  const defaultLaneName = "Default";

  const { events, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useBoardEventsInfiniteQuery({
      forId: idea?.challenge,
      ideaId: idea?._id,
      limit: 25,
      enabled: !!idea?.challenge && !!idea?._id,
    });

  if (isLoading) {
    return <Loader />;
  }

  if (events.length === 0) {
    return (
      <EmptyBox>
        This {t("generic.idea")} currently has no project board activity.
      </EmptyBox>
    );
  }

  return (
    <>
      {events.map((event) =>
        hasEventType(event.action) ? (
          <IdeaProjectEventItem
            key={event._id}
            event={event}
            showIdeaName={false}
            defaultLaneName={defaultLaneName}
            commentDisplay="formatted"
            interacted
          />
        ) : null,
      )}
      {isFetchingNextPage ? <Loader style={{ marginTop: 10 }} /> : null}
      {hasNextPage && !isFetchingNextPage ? (
        <Button
          size="small"
          onClick={() => fetchNextPage()}
          style={{ marginTop: 5, width: "100%" }}
        >
          Load more
        </Button>
      ) : null}
    </>
  );
};

export default ActivityManagement;
